// extracted by mini-css-extract-plugin
export default {"CardContent":"ItemNode_CardContent__msNEi","ArrowIcon":"ItemNode_ArrowIcon__Up+lY"};